import Components from './../Component';

export default class Breadcrumb extends Components {
  constructor($) {
    super($);
  }

  init(index, element) {
    this.$(element).find('li.has-others').each(function (index, li) {
      this.$(li).find('button').on('click', function (e) {
        this.closeAll(element);
        this.$(li).addClass('open');
        this.$(li).find('button').attr('aria-expanded', 'true');

          let interval = setInterval(function () {
            this.resize(index, element);
          }.bind(this), 100);
          setTimeout(function () {
            clearInterval(interval);
          }, 1000);

        this.resize(index, element);
        e.preventDefault();
      }.bind(this));
    }.bind(this));

    this.$(document).on('keydown', function (e) {
     if (e.keyCode == 27) {
        this.closeAll(element);
      }
    }.bind(this));

    this.$(document).on('click', function (e) {
      if (this.$(e.target).closest(element).length == 0) {
        this.closeAll(element);
      }
    }.bind(this));
  }

  resize(index, element) {
    this.$(element).find('li.has-others').each(function (index, li) {
      this.$(li).find('ul.others').css('top', -this.$(li).find('ul li.is-active').position().top);
    }.bind(this));
  }

  closeAll(element) {
    this.$(element).find('.open').removeClass('open');
    this.$(element).find('.open button').attr('aria-expanded', 'false');

  }
}
